/**
 * Centralized auth token store.
 *
 * AuthContext writes the current access token here on every onAuthStateChange
 * event (including TOKEN_REFRESHED). BaseApiService reads from here
 * synchronously — no getSession() calls, no race conditions.
 */

let _currentToken: string | null = null

export function setAuthToken(token: string | null): void {
  _currentToken = token
}

export function getAuthToken(): string | null {
  return _currentToken
}
